"use client"

import { useEffect, useState } from "react"
import { cn } from "@/lib/utils"

const sections = [
  { id: "overview", title: "Overview", number: "01" },
  { id: "capabilities", title: "Core Capabilities", number: "02" },
  { id: "readers", title: "Data Readers", number: "03" },
  { id: "architecture", title: "Architecture", number: "04" },
  { id: "api", title: "API", number: "05" },
  { id: "getting-started", title: "Getting Started", number: "06" },
]

export function TableOfContents() {
  const [activeSection, setActiveSection] = useState<string>("overview")

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      { rootMargin: "-20% 0% -70% 0%" }
    )

    sections.forEach(({ id }) => {
      const element = document.getElementById(id)
      if (element) observer.observe(element)
    })

    return () => observer.disconnect()
  }, [])

  const handleClick = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <nav className="space-y-1">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-4 px-3">
        On This Page
      </p>
      {sections.map((section) => (
        <button
          key={section.id}
          onClick={() => handleClick(section.id)}
          className={cn(
            "w-full text-left px-3 py-2 text-sm rounded-md transition-colors flex items-center gap-3",
            activeSection === section.id
              ? "bg-accent-primary/10 text-accent-primary font-medium"
              : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
          )}
        >
          <span className="text-xs opacity-60">{section.number}</span>
          {section.title}
        </button>
      ))}
    </nav>
  )
}
